import React, { Component } from 'react'
import './D_main.css'
import "font-awesome/css/font-awesome.min.css";
import LeftSide from './Components/Left_side';
import Center from './Components/Center';
import RightSide from './Components/Right_side';


export default class Dmain extends Component {
    constructor(props) {
        super(props);
        this.id = localStorage.getItem("id");
        this.state = {
            clicked: false
        }
    }

    postLogout = () => {
        this.props.postLogout()
    }
    handleClick = () => {
        this.setState({ clicked: !this.state.clicked });
    };


    render() {
        return (
            <div className="D_main">
                <div className='D_main_header'>
                    <header>
                        <div className="menu-icon" onClick={this.handleClick}>
                            <i
                                className={this.state.clicked ? "fas fa-times" : "fas fa-bars"}
                            ></i>
                        </div>
                        <a href='to_home'>
                            <i className="fas fa-home"></i>
                        </a>
                        <h2>Единое окно</h2>
                        <div className='Header_fio_container'>
                            <h3>{this.props.user_fio}</h3>
                            <p onClick={() => this.postLogout()}>Выход</p>
                        </div>
                    </header>
                </div>
                <div className={this.props.selected_menu > 2 ? 'D_main_body2 D_main_body' : 'D_main_body'}>
                    <div onClick={this.handleClick}
                        className={this.state.clicked ? "NavMenuItems active" : "NavMenuItems "}>
                        <LeftSide Select_menu={this.props.Select_menu.bind(this)} {...this.props} />
                    </div>

                    <Center
                        {...this.props}
                        SelectSearchType={this.props.SelectSearchType}
                        ChangeYear={this.props.ChangeYear}
                        ChangeEduc={this.props.ChangeEduc}
                        ChangeFaculty={this.props.ChangeFaculty}
                        ChangeRate={this.props.ChangeRate}
                        ChangeGroup={this.props.ChangeGroup}
                    />
                    {this.props.selected_menu < 3 ?
                        <RightSide
                            {...this.props}
                            postPropertiesInsertUpdate={this.props.postPropertiesInsertUpdate}
                            onChangeStartYear={this.props.onChangeStartYear}
                            onChangeEndYear={this.props.onChangeEndYear}
                            onChangeDescription={this.props.onChangeDescription}
                            postDescriptionInsert={this.props.postDescriptionInsert}
                            postDescriptionUpdate={this.props.postDescriptionUpdate}
                            postDescriptionDelete={this.props.postDescriptionDelete}
                            SelectStudent={this.props.SelectStudent}
                            SelectRepublic={this.props.SelectRepublic}
                            SelectOblast={this.props.SelectOblast}
                            SelectRaion={this.props.SelectRaion}
                        /> : null}
                </div>
            </div>
        )
    }
}
